module.exports = __webpack_public_path__ + "static/media/no-path-cover.8c0c8c30.png";